import { useState } from 'react'
import { useImagePickerContext } from '../ImagePickerContext'
import { reportError } from 'utils/error'
import { useStockVideoDownload } from 'hooks/queries/designer/useStockVideoDownload'
import { isVideo } from 'components/ImagePickerModal/utils'

export const useConfirm = () => {
  const context = useImagePickerContext()
  const { selectedImages, onConfirm, uploadImages } = context
  const [isConfirming, setIsConfirming] = useState(false)
  const { downloadHighRes } = useStockVideoDownload()

  const confirm = async () => {
    if (context.onBeforeConfirm) {
      const confirmed = await context.onBeforeConfirm(selectedImages)
      if (!confirmed) {
        return
      }
    }

    setIsConfirming(true)

    try {
      const files = await Promise.all(
        selectedImages.map(async (image) => {
          let url = image.source_url || image.url
          
          const isSelectedVideo = isVideo({
            url,
            type: image.mime_type,
          })
          
          if (isSelectedVideo && image.id) {
            const highResUrl = await downloadHighRes(image.id)
            if (highResUrl) {
              url = highResUrl
            }
          }
          
          const response = await fetch(url)
          const blob = await response.blob()
          return new File([blob], image.original_filename || 'filename', { type: blob.type })
        }),
      )
      const uploadedImages = await uploadImages(files, context)
      onConfirm(
        uploadedImages.map((image, i) => ({
          ...image,
          unsplash: selectedImages[i].unsplash,
        })),
        context,
      )
    } catch (error) {
      reportError(error)
    } finally {
      setIsConfirming(false)
    }
  }

  return { isConfirming, confirm }
}
